import { value } from '@takeshape/util';
import { updateAuthentication } from "../util/authentication.js";
import { hasEveryKey } from "../util/has.js";
import { getHealthCheck } from "../util/health.js";
const serviceProvider = {
    name: 'salsify',
    title: 'Salsify',
    description: 'The Salsify Commerce Experience Management (CommerceXM) Platform powers engaging shopping experiences at every stage of the buying journey.',
    categories: ['ecommerce', 'pim'],
    links: [
        { title: 'Homepage', url: 'https://www.salsify.com/' },
        { title: 'Docs', url: '/docs/services/providers/salsify' }
    ],
    serviceType: 'rest',
    introspectionType: 'salsify',
    createId: value('salsify'),
    getFormSchema: value({
        type: 'object',
        required: ['title', 'id', 'namespace', 'organizationId', 'channelId', 'authentication'],
        properties: {
            title: {
                title: 'Name',
                type: 'string',
                default: 'Salsify'
            },
            id: {
                title: 'Slug',
                type: 'string',
                pattern: '[0-9a-z_-]+',
                default: 'salsify'
            },
            namespace: {
                title: 'Namespace',
                type: 'string',
                pattern: '^[A-Z][A-Za-z]+$',
                default: 'Salsify'
            },
            organizationId: {
                title: 'Organization ID',
                type: 'string'
            },
            channelId: {
                title: 'Channel ID',
                type: 'string'
            },
            authentication: {
                title: 'Authentication',
                description: 'The following properties are encrypted and are obscured on this form to ensure the security of your data.',
                type: 'object',
                properties: {
                    token: {
                        title: 'API Key',
                        type: 'string',
                        '@sensitive': true
                    }
                },
                required: ['token']
            }
        }
    }),
    getFormConfig: value({
        order: ['title', 'id', 'namespace', 'organizationId', 'channelId', 'authentication'],
        properties: {
            title: {
                widget: 'singleLineText',
                instructions: 'A human-readable name for this service.'
            },
            id: {
                widget: 'singleLineText',
                instructions: 'A unique identifier for this service. Only lowercase letters, numbers, hyphen, and underscore are allowed.'
            },
            namespace: {
                widget: 'singleLineText',
                instructions: 'A namespace to use for any generated types or queries. For example, if you enter `Foo` your types will be named `Foo_Bar`.'
            },
            organizationId: {
                widget: 'singleLineText',
                instructions: 'Example: `https://app.salsify.com/orgs/s9999-9999-9999-9999` the ID is `s9999-9999-9999-9999`'
            },
            channelId: {
                widget: 'singleLineText',
                instructions: 'Example: `https://app.salsify.com/orgs/s9999-9999-9999-9999/channels/1234` the ID is `1234`'
            },
            authentication: {
                properties: {
                    token: {
                        widget: 'sensitiveField',
                        instructions: 'API Key from User Profile > API Access > API Key'
                    }
                },
                order: ['token']
            }
        }
    }),
    getConfig(formData) {
        const config = {
            id: formData.id,
            title: formData.title,
            provider: 'salsify',
            serviceType: 'rest',
            authenticationType: 'bearer',
            namespace: formData.namespace,
            options: {
                organizationId: formData.organizationId,
                channelId: formData.channelId,
                endpoint: `https://app.salsify.com/api/orgs/${formData.organizationId}`
            }
        };
        return updateAuthentication(config, formData, { type: 'bearer' });
    },
    isCompleteConfig: hasEveryKey(['authentication', 'options.endpoint', 'options.channelId', 'options.organizationId']),
    getHealthCheck: getHealthCheck({
        checkName: 'ping',
        endpoint: (serviceConfig) => `${serviceConfig.options.endpoint}/channels/${serviceConfig.options.channelId}/runs/latest`
    })
};
export default serviceProvider;
